/* eslint-disable */ import { memoEval, violationsComponent } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
export const anchorSinglePlatformBaseComponents = [
    attachComponent.withComponent(violationsComponent, 'default', true).withEntity('AnchorSinglePlatformBase').attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.$violations
        ], ($violations)=>({
            violations: $violations
        })))
];

//# sourceMappingURL=anchor-single-platform-base.js.map